export type BackgroundProcessEntry<T> = {
    type: BackgroundProcessType;
    result: T;
    status: BackgroundProcessStatus;
    errors: string[];
    startedAt: Date;
    finishedAt?: Date;
};

export enum BackgroundProcessStatus {
    Pending = "Pending",
    Completed = "Completed",
    Failed = "Failed",
}

export enum BackgroundProcessType {
    ExperimentSetup = "ExperimentSetup",
    FermenterRunSetup = "FermenterRunSetup",
    FileUpload = "FileUpload",
}
